<div class="debug-bar" *ngIf="globalsService.isDebug()">

    system={{globalsService.getSystem()}};
    apiURL={{globalsService.getApiUrl()}};
    ccsFrom={{globalsService.getCCSFrom()}}

    <br />

    ownerName={{globalsService.getOwnerName()}}; 
    ownerKey={{globalsService.getOwnerKey()}}; 
    ownerID={{globalsService.getOwnerID()}}; 
    loggedInOwnerName={{globalsService.getLoggedInOwnerName()}}; 
    datasetExternalID={{globalsService.getDatasetExternalID()}}; 
    activeTargetID={{globalsService.getActiveTargetID()}}; 
    activeDatasetID={{globalsService.getActiveDatasetID()}}; 
    activeDatasetIteration={{globalsService.getActiveDatasetIteration()}}; 
    activeRespondentID={{globalsService.getActiveRespondentID()}}; 
    respondentExternalID={{globalsService.getRespondentExternalID()}}; 
    activeRoleID={{globalsService.getActiveRoleID()}}; 
    dashboardID={{globalsService.getActiveDashboardID()}}; 
    impersonationMode={{globalsService.getImpersonationMode()}}; 
    isGlobalPreview={{globalsService.isGlobalPreview()}};
    isLibraryPreview={{globalsService.isLibraryPreview()}};
    isSimple={{globalsService.isSimple()}};
    isSuperUser={{globalsService.isSuperUser()}}; 
    isAllowDebug={{globalsService.isAllowDebug()}}; 
    isAllowConsoleLog={{globalsService.isAllowConsoleLog()}}; 

    <br />

    currentUrl={{globalsService.getCurrentURL()}}

</div>